<template>
  <v-container class="pa-0 ma-0">
    <v-card outlined class="pa-4 ma-0" style="height: 413px">
      <!-- title-->
      <v-container class="chart-header d-flex flex-column pa-0 ma-0">
        <v-card-text class="pa-0 ma-0 text-body-1">
          {{ $t("cost_by_department") }}
        </v-card-text>
        <v-card-text class="pa-0 ma-0 text-body-2" style="color: #717182">
          {{ $t("cost_distribution_across_units") }}
        </v-card-text>
      </v-container>
      <!-- bar chart-->
      <apexchart
        v-if="hasData"
        type="bar"
        height="320"
        :series="series"
        :options="chartOptions"
      />
      <v-container
        v-else
        class="pa-0 ma-0 d-flex flex-column align-center justify-center"
        style="height: 337px"
      >
        <img
          :src="require('@/assets/dashboard/no-data(3).png')"
          max-width="100"
          height="100"
          contain
          class="mb-3"
        />
        <v-card-text class="text-body-2 grey--text text-center">
          {{ $t("nothing-for-render") }}
        </v-card-text>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
export default {
  name: "costByCategoryChart",
  props: {
    filterChart: {
      type: Object,
      default: null,
    },
    advanceFilter: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      categories: [],
      loading: false,
    };
  },
  computed: {
    hasData() {
      return this.series[0]?.data?.some((val) => val > 0);
    },
    series() {
      let lable = this.categories.map((item) => item.value);
      return [
        {
          name: this.$t("purchase_amount"),
          data: lable,
        },
      ];
    },
    chartOptions() {
      return {
        chart: {
          type: "bar",
          toolbar: { show: false },
          fontFamily: "IRANSans",
        },

        colors: ["#EF4444"],

        plotOptions: {
          bar: {
            borderRadius: 6,
            columnWidth: "55%",
          },
        },

        dataLabels: {
          enabled: false,
        },

        xaxis: {
          categories: this.categories.map((i) => i.name),
          labels: {
            offsetY: 5,
          },
        },

        yaxis: {
          labels: {
            style: {
              fontSize: "10px",
            },
            offsetX: this.$vuetify.rtl ? -50 : 0,
            formatter: (val) =>
              val.toLocaleString("fa-IR") + this.$store.state.currency.name,
          },
        },

        tooltip: {
          y: {
            formatter: (val) =>
              `${val.toLocaleString("fa-IR")} ${this.$store.state.currency.name}`,
          },
        },

        grid: {
          strokeDashArray: 4,
          padding: {
            bottom: 9,
          },
        },
      };
    },
  },
  watch: {
    filterChart: {
      deep: true,
      handler(newVal) {
        this.this.getCostBycategory();
        newVal;
      },
    },

    advanceFilter: {
      deep: true,
      handler(newVal) {
        this.getCostBycategory(newVal);
      },
    },
  },
  mounted() {
    this.getCostBycategory();
  },
  methods: {
    getCostBycategory(filters = {}) {
      const hasDefaultDate = !!filters?.fromDate && !!filters?.toDate;
      const Type = hasDefaultDate ? false : "year";
      let UserList = [];
      let ProductList = [];
      if (
        filters.UserList != undefined &&
        filters.UserList != null &&
        filters.UserList != []
      ) {
        UserList = filters?.UserList.map((u) => u.id);
      }
      if (
        filters.products != undefined &&
        filters.products != null &&
        filters.products != []
      ) {
        ProductList = filters?.products.map((p) => p.id);
      }
      var app = this;
      app.loading = true;
      this.$axios
        .get(this.$endpoint + "dashboard/charts/cost-by-group", {
          params: {
            dateType: Type,
            fromDate: filters.fromDate || null,
            toDate: filters.toDate || null,
            status: filters.sellStatus || [],
            accountIds: filters.account || [],
            branch: filters.branch || [],
            UserList: UserList || [],
            minAmount: filters.amountRange?.[0] ?? null,
            maxAmount: filters.amountRange?.[1] ?? null,
            ProductList: ProductList || [],
            productGroup: filters.productGroup || null,
            entrepot: filters.entrepot || null,
            attachment: filters.attachments || null,
            receipt: filters.Receipt || null,
            category: filters.category || null,
            minAmountTax: filters.amountRangeTax?.[0] ?? null,
            maxAmountTax: filters.amountRangeTax?.[1] ?? null,
            invoice_status: filters.status || null,
          },
        })
        .then((response) => {
          const res = response.data.data.costByGroup || [];
          app.categories = res
            .map((item) => ({
              name: item.account_name,
              value: Math.abs(Number(item.current || 0)),
            }))
            .sort((a, b) => b.value - a.value)
            .slice(0, 10);
        })
        .catch((err) => {
          app.loading = false;
        })
        .finally(() => {
          app.loading = false;
        });
    },
  },
};
</script>

<style scoped>
::v-deep .v-btn:not(.v-btn--round).v-size--small {
  min-width: 30px;
}
::v-deep .v-text-field.v-text-field--outlined fieldset {
  border-color: #d9d9d9;
}
.chart-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
}
</style>
